module.exports = __webpack_public_path__ + "img/icon-huay.37119e8f.png";